import { render, staticRenderFns } from "./AdditionalItem.vue?vue&type=template&id=139bc4e3"
import script from "./AdditionalItem.vue?vue&type=script&lang=js"
export * from "./AdditionalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports